var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/CommonStory/CommonStoryText.jinja"] = require( "front/components/CommonStory/CommonStoryText.jinja" );
dependencies["front/components/CommonStory/CommonStoryColumns.jinja"] = require( "front/components/CommonStory/CommonStoryColumns.jinja" );
dependencies["front/components/CommonStory/CommonStoryImage.jinja"] = require( "front/components/CommonStory/CommonStoryImage.jinja" );
dependencies["front/components/CommonStory/CommonStoryQuote.jinja"] = require( "front/components/CommonStory/CommonStoryQuote.jinja" );
dependencies["front/components/CommonStory/CommonStoryVideo.jinja"] = require( "front/components/CommonStory/CommonStoryVideo.jinja" );
dependencies["front/components/CommonStory/CommonStoryGallery.jinja"] = require( "front/components/CommonStory/CommonStoryGallery.jinja" );
dependencies["front/components/CommonStory/CommonStoryMembers.jinja"] = require( "front/components/CommonStory/CommonStoryMembers.jinja" );
dependencies["front/components/CommonStory/CommonStoryBanner.jinja"] = require( "front/components/CommonStory/CommonStoryBanner.jinja" );
dependencies["front/components/CommonStory/CommonStoryButton.jinja"] = require( "front/components/CommonStory/CommonStoryButton.jinja" );
dependencies["front/components/CommonStory/CommonStoryDownloads.jinja"] = require( "front/components/CommonStory/CommonStoryDownloads.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/CommonStory/CommonStory.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/CommonStory/CommonStory.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/CommonStory/CommonStoryText.jinja", false, "assets/app/front/components/CommonStory/CommonStory.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "CommonStoryText")) {
var t_7 = t_4.CommonStoryText;
} else {
cb(new Error("cannot import 'CommonStoryText'")); return;
}
context.setVariable("CommonStoryText", t_7);
output += "\n";
env.getTemplate("front/components/CommonStory/CommonStoryColumns.jinja", false, "assets/app/front/components/CommonStory/CommonStory.jinja", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(Object.prototype.hasOwnProperty.call(t_8, "CommonStoryColumns")) {
var t_11 = t_8.CommonStoryColumns;
} else {
cb(new Error("cannot import 'CommonStoryColumns'")); return;
}
context.setVariable("CommonStoryColumns", t_11);
output += "\n";
env.getTemplate("front/components/CommonStory/CommonStoryImage.jinja", false, "assets/app/front/components/CommonStory/CommonStory.jinja", false, function(t_13,t_12) {
if(t_13) { cb(t_13); return; }
t_12.getExported(function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
if(Object.prototype.hasOwnProperty.call(t_12, "CommonStoryImage")) {
var t_15 = t_12.CommonStoryImage;
} else {
cb(new Error("cannot import 'CommonStoryImage'")); return;
}
context.setVariable("CommonStoryImage", t_15);
output += "\n";
env.getTemplate("front/components/CommonStory/CommonStoryQuote.jinja", false, "assets/app/front/components/CommonStory/CommonStory.jinja", false, function(t_17,t_16) {
if(t_17) { cb(t_17); return; }
t_16.getExported(function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
if(Object.prototype.hasOwnProperty.call(t_16, "CommonStoryQuote")) {
var t_19 = t_16.CommonStoryQuote;
} else {
cb(new Error("cannot import 'CommonStoryQuote'")); return;
}
context.setVariable("CommonStoryQuote", t_19);
output += "\n";
env.getTemplate("front/components/CommonStory/CommonStoryVideo.jinja", false, "assets/app/front/components/CommonStory/CommonStory.jinja", false, function(t_21,t_20) {
if(t_21) { cb(t_21); return; }
t_20.getExported(function(t_22,t_20) {
if(t_22) { cb(t_22); return; }
if(Object.prototype.hasOwnProperty.call(t_20, "CommonStoryVideo")) {
var t_23 = t_20.CommonStoryVideo;
} else {
cb(new Error("cannot import 'CommonStoryVideo'")); return;
}
context.setVariable("CommonStoryVideo", t_23);
output += "\n";
env.getTemplate("front/components/CommonStory/CommonStoryGallery.jinja", false, "assets/app/front/components/CommonStory/CommonStory.jinja", false, function(t_25,t_24) {
if(t_25) { cb(t_25); return; }
t_24.getExported(function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
if(Object.prototype.hasOwnProperty.call(t_24, "CommonStoryGallery")) {
var t_27 = t_24.CommonStoryGallery;
} else {
cb(new Error("cannot import 'CommonStoryGallery'")); return;
}
context.setVariable("CommonStoryGallery", t_27);
output += "\n";
env.getTemplate("front/components/CommonStory/CommonStoryMembers.jinja", false, "assets/app/front/components/CommonStory/CommonStory.jinja", false, function(t_29,t_28) {
if(t_29) { cb(t_29); return; }
t_28.getExported(function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
if(Object.prototype.hasOwnProperty.call(t_28, "CommonStoryMembers")) {
var t_31 = t_28.CommonStoryMembers;
} else {
cb(new Error("cannot import 'CommonStoryMembers'")); return;
}
context.setVariable("CommonStoryMembers", t_31);
output += "\n";
env.getTemplate("front/components/CommonStory/CommonStoryBanner.jinja", false, "assets/app/front/components/CommonStory/CommonStory.jinja", false, function(t_33,t_32) {
if(t_33) { cb(t_33); return; }
t_32.getExported(function(t_34,t_32) {
if(t_34) { cb(t_34); return; }
if(Object.prototype.hasOwnProperty.call(t_32, "CommonStoryBanner")) {
var t_35 = t_32.CommonStoryBanner;
} else {
cb(new Error("cannot import 'CommonStoryBanner'")); return;
}
context.setVariable("CommonStoryBanner", t_35);
output += "\n";
env.getTemplate("front/components/CommonStory/CommonStoryButton.jinja", false, "assets/app/front/components/CommonStory/CommonStory.jinja", false, function(t_37,t_36) {
if(t_37) { cb(t_37); return; }
t_36.getExported(function(t_38,t_36) {
if(t_38) { cb(t_38); return; }
if(Object.prototype.hasOwnProperty.call(t_36, "CommonStoryButton")) {
var t_39 = t_36.CommonStoryButton;
} else {
cb(new Error("cannot import 'CommonStoryButton'")); return;
}
context.setVariable("CommonStoryButton", t_39);
output += "\n";
env.getTemplate("front/components/CommonStory/CommonStoryDownloads.jinja", false, "assets/app/front/components/CommonStory/CommonStory.jinja", false, function(t_41,t_40) {
if(t_41) { cb(t_41); return; }
t_40.getExported(function(t_42,t_40) {
if(t_42) { cb(t_42); return; }
if(Object.prototype.hasOwnProperty.call(t_40, "CommonStoryDownloads")) {
var t_43 = t_40.CommonStoryDownloads;
} else {
cb(new Error("cannot import 'CommonStoryDownloads'")); return;
}
context.setVariable("CommonStoryDownloads", t_43);
output += "\n\n";
var macro_t_44 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_45 = "";t_45 += "\n    <div class=\"CommonStory\">\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"contenthtml")) {
t_45 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"contenthtml")), env.opts.autoescape);
t_45 += "\n        ";
;
}
else {
t_45 += "\n            ";
frame = frame.push();
var t_48 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"content");
if(t_48) {t_48 = runtime.fromIterator(t_48);
var t_47 = t_48.length;
for(var t_46=0; t_46 < t_48.length; t_46++) {
var t_49 = t_48[t_46];
frame.set("CommonStory", t_49);
frame.set("loop.index", t_46 + 1);
frame.set("loop.index0", t_46);
frame.set("loop.revindex", t_47 - t_46);
frame.set("loop.revindex0", t_47 - t_46 - 1);
frame.set("loop.first", t_46 === 0);
frame.set("loop.last", t_46 === t_47 - 1);
frame.set("loop.length", t_47);
t_45 += "\n                ";
if(runtime.memberLookup((t_49),"component") == "text") {
t_45 += "\n                    ";
t_45 += runtime.suppressValue((lineno = 20, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonStoryText"), "CommonStoryText", context, [runtime.makeKeywordArgs({"data": {"content": t_49}})])), env.opts.autoescape);
t_45 += "\n                ";
;
}
t_45 += "\n\n                ";
if(runtime.memberLookup((t_49),"component") == "columns") {
t_45 += "\n                    ";
t_45 += runtime.suppressValue((lineno = 24, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonStoryColumns"), "CommonStoryColumns", context, [runtime.makeKeywordArgs({"data": {"content": t_49}})])), env.opts.autoescape);
t_45 += "\n                ";
;
}
t_45 += "\n\n                ";
if(runtime.memberLookup((t_49),"component") == "image") {
t_45 += "\n                    ";
t_45 += runtime.suppressValue((lineno = 28, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonStoryImage"), "CommonStoryImage", context, [runtime.makeKeywordArgs({"data": {"content": t_49}})])), env.opts.autoescape);
t_45 += "\n                ";
;
}
t_45 += "\n\n                ";
if(runtime.memberLookup((t_49),"component") == "quote") {
t_45 += "\n                    ";
t_45 += runtime.suppressValue((lineno = 32, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonStoryQuote"), "CommonStoryQuote", context, [runtime.makeKeywordArgs({"data": {"content": t_49}})])), env.opts.autoescape);
t_45 += "\n                ";
;
}
t_45 += "\n\n                ";
if(runtime.memberLookup((t_49),"component") == "video") {
t_45 += "\n                    ";
t_45 += runtime.suppressValue((lineno = 36, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonStoryVideo"), "CommonStoryVideo", context, [runtime.makeKeywordArgs({"data": {"content": t_49}})])), env.opts.autoescape);
t_45 += "\n                ";
;
}
t_45 += "\n\n                ";
if(runtime.memberLookup((t_49),"component") == "gallery") {
t_45 += "\n                    ";
t_45 += runtime.suppressValue((lineno = 40, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonStoryGallery"), "CommonStoryGallery", context, [runtime.makeKeywordArgs({"data": {"content": t_49}})])), env.opts.autoescape);
t_45 += "\n                ";
;
}
t_45 += "\n\n                ";
if(runtime.memberLookup((t_49),"component") == "members") {
t_45 += "\n                    ";
t_45 += runtime.suppressValue((lineno = 44, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonStoryMembers"), "CommonStoryMembers", context, [runtime.makeKeywordArgs({"data": {"content": t_49}})])), env.opts.autoescape);
t_45 += "\n                ";
;
}
t_45 += "\n\n                ";
if(runtime.memberLookup((t_49),"component") == "banner") {
t_45 += "\n                    ";
t_45 += runtime.suppressValue((lineno = 48, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonStoryBanner"), "CommonStoryBanner", context, [runtime.makeKeywordArgs({"data": {"content": t_49}})])), env.opts.autoescape);
t_45 += "\n                ";
;
}
t_45 += "\n\n                ";
if(runtime.memberLookup((t_49),"component") == "link") {
t_45 += "\n                    ";
t_45 += runtime.suppressValue((lineno = 52, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonStoryButton"), "CommonStoryButton", context, [runtime.makeKeywordArgs({"data": {"content": t_49}})])), env.opts.autoescape);
t_45 += "\n                ";
;
}
t_45 += "\n\n                ";
if(runtime.memberLookup((t_49),"component") == "downloads") {
t_45 += "\n                    ";
t_45 += runtime.suppressValue((lineno = 56, colno = 41, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonStoryDownloads"), "CommonStoryDownloads", context, [runtime.makeKeywordArgs({"data": {"content": t_49}})])), env.opts.autoescape);
t_45 += "\n                ";
;
}
t_45 += "\n            ";
;
}
}
frame = frame.pop();
t_45 += "\n        ";
;
}
t_45 += "</div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_45);
});
context.addExport("CommonStory");
context.setVariable("CommonStory", macro_t_44);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})})})})})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/CommonStory/CommonStory.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonStory/CommonStory.jinja
// module id = 19
// module chunks = 0